module.exports = __webpack_public_path__ + "static/media/icon-delete.c0b31516.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-delete.svg
// module id = 1954
// module chunks = 3